import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgApple = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.1803 5.0942C14.4952 5.90485 13.3991 6.54424 12.303 6.4529C12.166 5.3568 12.7026 4.1922 13.3306 3.47288C14.0157 2.63939 15.2145 2.04567 16.185 2C16.2992 3.14177 15.8539 4.2607 15.1803 5.0942ZM16.1736 6.66984C14.5865 6.5785 13.2278 7.57184 12.4743 7.57184C11.7093 7.57184 10.5561 6.71551 9.30015 6.73834C7.66742 6.76118 6.14887 7.68601 5.31538 9.1589C3.60272 12.1047 4.87009 16.4662 6.52565 18.8639C7.33631 20.0514 8.30681 21.353 9.5856 21.3073C10.7959 21.2617 11.2754 20.5195 12.7369 20.5195C14.2098 20.5195 14.6322 21.3073 15.911 21.2845C17.2355 21.2617 18.0689 20.0971 18.8796 18.9096C19.8044 17.5623 20.1812 16.2493 20.2041 16.1808C20.1812 16.1579 17.6465 15.1874 17.6237 12.2645C17.6008 9.82112 19.6218 8.65652 19.7131 8.58801C18.5713 6.89819 16.7902 6.71551 16.1736 6.66984Z",
		fill: "#999999"
	})
});
export default SvgApple;
